import axios from 'axios';
import API from "../config/API";

export const stocktakeService = {
    createStocktake,
    getStocktakeById,
    updateStocktake,
    completeStocktake,
    getStocktakeHistory,
    deleteStocktake
};

/**
 * Create a new stock take
 * @param {Object} params - Stock take data
 * @returns {Promise} - Created stock take
 */
function createStocktake(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    return axios.post(API.CREATE_STOCKTAKE, params, { headers: headers });
}

/**
 * Get stock take by ID
 * @param {string} stocktakeId - Stock take ID
 * @returns {Promise} - Stock take object
 */
function getStocktakeById(stocktakeId) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    return axios.get(`${API.GET_STOCKTAKE}/${stocktakeId}`, { headers: headers });
}

/**
 * Update a stock take
 * @param {Object} params - Update parameters
 * @returns {Promise} - Updated stock take
 */
function updateStocktake(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    return axios.put(API.UPDATE_STOCKTAKE, params, { headers: headers });
}

/**
 * Complete a stock take
 * @param {Object} params - Parameters with stocktakeId and items
 * @returns {Promise} - Completed stock take
 */
function completeStocktake(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    return axios.post(API.COMPLETE_STOCKTAKE, params, { headers: headers });
}

/**
 * Get stock take history with pagination and filters
 * @param {Object} params - Query parameters
 * @returns {Promise} - Object with stock takes and total count
 */
function getStocktakeHistory(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    return axios.get(API.GET_STOCKTAKE_HISTORY, {
        headers: headers,
        params: {
            salonId: params.salonId,
            page: params.page || 1,
            limit: params.limit || 10,
            startDate: params.startDate,
            endDate: params.endDate
        }
    });
}

/**
 * Delete a stock take
 * @param {string} stocktakeId - Stock take ID to delete
 * @returns {Promise} - Result of the delete operation
 */
function deleteStocktake(stocktakeId) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    // Use the DELETE_STOCKTAKE endpoint
    return axios.delete(`${API.DELETE_STOCKTAKE}/${stocktakeId}`, { headers: headers });
}